import { Colors } from "../../config/DesignConstants";
import BaseEntity from "../../core/entity/BaseEntity";
import { V2d } from "../../core/Vector";
import { TextAnchor, VectorText } from "../text/VectorText";
import ScoreManager from "../util/ScoreManager";

const MARGIN = 20; // Margin in pixels for positioning
export default class ScoreDisplay extends BaseEntity {
  private text: VectorText;

  constructor() {
    super();

    // Create score text (top-left)
    this.text = this.addChild(
      new VectorText({
        text: "SCORE: 0",
        position: new V2d(MARGIN, MARGIN),
        scale: 2.4,
        color: Colors.CYAN,
        strokeWidth: 2,
        anchor: TextAnchor.LEFT,
        layer: "ui",
      }),
    );
  }

  onRender(): void {
    // Update score
    const currentScore = this.getCurrentScore();
    this.text.text = `SCORE: ${currentScore}`;
  }

  private getCurrentScore(): number {
    const scoreManager = this.game?.entities.getById(
      "scoreManager",
    ) as ScoreManager;
    return scoreManager?.score ?? 0;
  }
}
